import { useState, useEffect } from 'react'

const useScrollAnimation = (moduleName, threshold = 200) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const module = document.getElementById(moduleName)
      if (module) {
        const moduleTop = module.getBoundingClientRect().top
        if (window.innerHeight - moduleTop >= threshold) {
          setIsVisible(true)
        }
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [moduleName, threshold])

  return isVisible
}

export default useScrollAnimation
